import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

i18n
  // detect available locale files
  .use(Backend)
  // detect user language
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  .init({
    debug: false,
    fallbackLng: window._env_.DEFAULT_LANG, //default language
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    backend: {
      loadPath: process.env.PUBLIC_URL + '/locales/{{lng}}.json',
    },
  });

// verifayda-ui-fix.js injects text outside React; it reads translations from
// this instance so both use the same locale bundle.
window.vfI18n = i18n;

const syncDocumentLanguage = (lng) => {
  if (!lng) return;
  document.documentElement.lang = lng;
  window.dispatchEvent(new CustomEvent('vf-lang-change', { detail: lng }));
};
i18n.on('languageChanged', syncDocumentLanguage);
i18n.on('loaded', () => syncDocumentLanguage(i18n.language));

export default i18n;
